"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignAdProduct1ToJSON = exports.CampaignAdProduct1FromJSONTyped = exports.CampaignAdProduct1FromJSON = exports.CampaignAdProduct1 = void 0;
/**
 * The ad product of the campaign being created.
 * @export
 */
exports.CampaignAdProduct1 = {
    Unset: 'UNSET',
    Unknown: 'UNKNOWN',
    Fito: 'FITO',
    Span: 'SPAN',
    Sbl: 'SBL',
    FirstImpressionStream: 'FIRST_IMPRESSION_STREAM',
    Guaranteed: 'GUARANTEED',
    Hpto: 'HPTO',
    FormatsTest: 'FORMATS_TEST'
};
function CampaignAdProduct1FromJSON(json) {
    return CampaignAdProduct1FromJSONTyped(json, false);
}
exports.CampaignAdProduct1FromJSON = CampaignAdProduct1FromJSON;
function CampaignAdProduct1FromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignAdProduct1FromJSONTyped = CampaignAdProduct1FromJSONTyped;
function CampaignAdProduct1ToJSON(value) {
    return value;
}
exports.CampaignAdProduct1ToJSON = CampaignAdProduct1ToJSON;
